import React, { useState, useEffect, Suspense, memo } from "react";
import { Link } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import LoadingSkeleton from "../../Component/react-loading-skeleteon/LoadingSkeleton";
import LazyImage from "./LazyImage";
// import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from "react-router-dom";
import Currency from "Component/Currency/Currency";
import { converCryptoToDollar } from "helpers/constants";

export default memo(function CategoryCardPhysical(props) {
  const categoryData = props.data;

  useEffect(() => {
    console.log(" ", categoryData);
  }, [categoryData]);

  const navigate = useNavigate();
  const [symbol, setSymbol] = useState("$");

  const [convertIntoCurrency, setConvertIntoCurrency] = useState("USD");
  const [usdPrice, setUsdPrice] = useState(0);
  const [imageLoading, setImageLoading] = useState(false);
  const [PhysicalArt, setPhysicalArt] = useState({ isPhysical: false });

  const [timeLeft, setTimeLeft] = useState();
  useEffect(() => {
    if (categoryData?.nft_id?.saleType === "auction") {
      setTimeLeft(convertTimestampToDate(categoryData?.auction_time));
    }
    console.log("categoryData", categoryData);
  }, [categoryData]);

  function convertTimestampToDate(timestamp) {
    const date = new Date(timestamp * 1000);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageLoading(true);
    };
    console.log("categoryDataPhy", categoryData);
    img.src = categoryData?.listing_image_id?.link;
    console.log("imageee,", img.src);
    // img.scr1=
  });
  const setCurrnencyTobeConverted = (currency, symbol) => {
    setConvertIntoCurrency(currency);
    setSymbol(symbol);
  };

  useEffect(() => {
    if (categoryData?.isPhysical) {
      setPhysicalArt({ isPhysical: true });
      console.log("categoryData isPhysical:", categoryData.isPhysical);
    }
  }, [categoryData]);
  useEffect(() => {
    console.log("set value", PhysicalArt);
  }, [PhysicalArt]);

  return (
    <>
      {imageLoading === true ? (
        <div className="artItemBoxNew">
          <div
            className="imgBox"
            onClick={() =>
              navigate(
                categoryData?.sellType === "auction"
                  ? `/liveAuctionNft/${props?.data?._id}`
                  : categoryData?.isPhysicalNew === true
                  ? `/nftsale/physical/${props?.data?._id}`
                  : `/nftsale/${props?.data?._id}`,
                { state: PhysicalArt }
              )
            }
            style={{ cursor: "pointer" }}
          >
            <div class="artistNameBox">
              <div className="d-flex align-items-center gap-2">
                <Suspense>
                  <img src={categoryData?.owner_id?.profileImage} alt="" />
                </Suspense>{" "}
                <h5>
                  {categoryData?.owner_id?.name?.length > 8
                    ? categoryData?.owner_id?.name?.slice(0, 8) + "..."
                    : categoryData?.owner_id?.name}{" "}
                </h5>
              </div>
            </div>
            {/* <div className="imginn"> */}
            {/* <LazyLoadImage style={{ width: '100%', height: '100%' }}
                  src={categoryData?.nft_id?.image_id?.image?.water_mark_image_link
                    ? categoryData?.nft_id?.image_id?.image
                      ?.water_mark_image_link
                    : categoryData?.nft_id?.image_id?.image?.link}
                /> */}

            {/* <MyImageComponent src={categoryData?.nft_id?.image_id?.image?.water_mark_image_link
                  ? categoryData?.nft_id?.image_id?.image
                    ?.water_mark_image_link
                  : categoryData?.nft_id?.image_id?.image?.link} /> */}
            {/* </div> */}
            {/* <div className="imginn" style={{ width: '300px', height: '300px', position: 'relative' }} >
                <LazyLoadImage
                  style={{ width: '100%', height: '100%' }}
                  src={categoryData?.nft_id?.image_id?.image?.water_mark_image_linkf
                    ? categoryData?.nft_id?.image_id?.image
                      ?.water_mark_image_link
                    : categoryData?.nft_id?.image_id?.image?.link}
                />ff
              </div> */}
            {/* <div className="imginn"> */}
            {/* <Suspense>  */}
            <LazyImage
              src={
                categoryData?.listing_image_id?.water_mark_image_link
                  ? categoryData?.listing_image_id?.water_mark_image_link
                  : categoryData?.listing_image_id?.link
              }
              alt="Placeholder Image"
            />

            {/* </Suspense> */}
            {/* </div> */}
            {categoryData?.nft_id &&
              categoryData?.nft_id?.saleType === "auction" && (
                <button className="priceTag">
                  Current Bid - {categoryData?.current_price}{" "}
                  <img
                    src="/images/svg/maticIcon.svg"
                    width={25}
                    height={25}
                    alt="Matic"
                  />{" "}
                </button>
              )}
          </div>
          <div className="contBox">
            <div className="arthead">
              <h2 className="productName" title={categoryData?.item_info?.name}>
                {categoryData?.item_info?.name}
              </h2>
            </div>
            {categoryData?.nft_id?.saleType === "auction" ? (
              <div className="auctionPrice mt-2">
                <div className="priceBoxAuc mb-3">
                  <h2>Opening Amount</h2>
                  <div>
                    <h3>
                      {categoryData?.price}{" "}
                      <img
                        src="/images/svg/maticIcon.svg"
                        width={18}
                        height={18}
                        alt="Matic"
                      />
                    </h3>
                    {/* <div class="artRate">
                    <h5>  {symbol+" "+ Number(usdPrice).toFixed(5)} </h5>
                    <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted} />
                    
                  </div> */}
                  </div>
                </div>
                <div className="priceBoxAuc artPriceBox">
                  <div className="endsaletxt">
                    <h2>End In</h2>
                    <h3>{timeLeft}</h3>
                  </div>
                  <ul>
                    <li>
                      <img
                        src="/images/svg/eyeNew.svg"
                        width="25"
                        height="25"
                        alt=""
                      />{" "}
                      <h5>{categoryData?.view_count}</h5>
                    </li>
                    <li>
                      <img
                        src="/images/svg/likeNew.svg"
                        width="25"
                        height="25"
                        alt=""
                      />
                      <h5>{categoryData?.like_count}</h5>
                    </li>
                  </ul>
                </div>
              </div>
            ) : (
              <>
                <div class="artPriceBox align-items-start mt-2">
                  {categoryData?.nft_id?.saleType === "fixed" && (
                    <div>
                      <div class="artRate d-block text-start">
                        {/* <h4> {Number(categoryData?.nft_id?.price).toFixed(5)} </h4>
                    <img
                      src="/images/svg/maticIcon.svg"
                      width="18"
                      height="18"
                      alt=""
                    /> */}
                        <h4>
                          {symbol + " " + Number(usdPrice?.data).toFixed(5)}{" "}
                        </h4>
                        <Currency
                          setCurrnencyTobeConverted={setCurrnencyTobeConverted}
                        />
                      </div>
                    </div>
                  )}
                  <ul>
                    <li>
                      <img
                        src="/images/svg/eyeNew.svg"
                        width="25"
                        height="25"
                        alt=""
                      />{" "}
                      <h5>{categoryData?.view_count}</h5>
                    </li>
                    <li>
                      <img
                        src="/images/svg/likeNew.svg"
                        width="25"
                        height="25"
                        alt=""
                      />
                      <h5>{categoryData?.like_count}</h5>
                    </li>
                  </ul>
                </div>
                {/* <div class="artPriceBox align-items-baseline mt-2">
              <div class="artRate">
                          <h5>{symbol+" "+ Number(usdPrice?.data).toFixed(5)} </h5>
                          <Currency setCurrnencyTobeConverted={setCurrnencyTobeConverted}  />
                         
                        </div>
                        </div> */}
              </>
            )}

            <button
              className="exploreBtn"
              onClick={() =>
                navigate(
                  categoryData?.sellType === "auction"
                    ? `/liveAuctionNft/${props?.data?._id}`
                    : categoryData?.isPhysicalNew === true
                    ? `/nftsale/physical/${props?.data?._id}`
                    : `/nftsale/${props?.data?._id}`,
                  { state: PhysicalArt }
                )
              }
              style={{ cursor: "pointer" }}
            >
              Explore Now
            </button>
          </div>
        </div>
      ) : (
        <div className="artItemBoxNew">
          <div className="imgBox" style={{ aspectRatio: 1 / 1 }}>
            <LoadingSkeleton count={1} style={{ height: "100%" }} />
          </div>
        </div>
      )}
    </>
  );
});
